module.exports = __webpack_public_path__ + "static/virtual-reality-american-society-for-cell-biology-a84494d556db131221b716b173c8c07c.jpg";